import Config from 'services/config/config';

export async function reverseGeocode(lat, lng) {
  const latitude = Number(lat);
  const longitude = Number(lng);

  if (!latitude || !longitude || Number.isNaN(latitude) || Number.isNaN(longitude)) {
    return null;
  }

  const url = `${Config.googleAPI.geocode}json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    const result = data?.results?.[0];

    if (!result) {
      return null;
    }

    return {
      formattedAddress: result.formatted_address,
      locality:
        result.address_components?.find((c) => c.types?.includes('locality'))
          ?.long_name || '',
    };
  } catch {
    return null;
  }
}
